import apiFetech from "../configs/axios";
import { API_SLIDER_URL } from "../constants/urls";

export class SliderServices {
  static getLast() {
    var config = {
      method: "get",
      url: API_SLIDER_URL
    };
    return apiFetech(config);
  }
}
